module.exports = __webpack_public_path__ + "static/img/verify2.0e79dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify2.png
// module id = Dyvw
// module chunks = 0